module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_game_machine_7558d40c65f8cfb0c540e87bb7992861.png";